export const TOC_ROUTES = {
  TITLE: 'Terms of Service',
  ABSOLUTE_PATH: '/toc',
  EXACT_PATH: '/toc',
};
